import React, { Component } from 'react';
import { isEmpty} from 'lodash';
import { connect } from 'react-redux';
import { buildAccountsActivitySummary } from 'state/performance/ActivitySummarySelectors';
import { AccountNameRenderer } from 'services/TableUtils';
import {
  autoGroupColumnDef,
  autoGroupColumnDefMobile,
  ColumnDefFactory,
  defaultColDef
} from 'components/layouts/Activity/ColumnDefs';
import { isDesktopLayout } from 'state/view/ViewSelectors';
import FluctuationRenderer from 'components/shared/FluctuationRenderer/FluctuationRenderer';
import { getActivitySummaryFilter } from 'state/performance/ActivitySummaryFilterSelectors';
import {
  has529Only,
  hasAlaska529Only
} from 'state/performance/PerformancePageSelectors';
import {
  getBrokerageAccountsFromSweepMap,
  getHasPershingAccounts
} from 'state/account/AccountSelectors';

const ActivitySummaryDataProvider = (WrappedComponent) => {
  class ActivitySummaryData extends Component {
    frameworkComponents = {
      accountNameRenderer: AccountNameRenderer,
      adjustmentsRenderer: FluctuationRenderer,
      marketFluctuationRenderer: FluctuationRenderer
    };

    generateColumnDefs = (
      accounts,
      retirementOrder = false,
      has529Only = false,
      ownsPershingAccounts = false,
      hasAlaska529Only = false
    ) => {
      if (isEmpty(accounts)) {
        return [];
      }

      const columnDefFactory = new ColumnDefFactory(
        retirementOrder,
        has529Only,
        hasAlaska529Only
      );
      let columnDefOrder = [
        'personalInvestment',
        'retirementAccount',
        'typeAndOwners',
        'productType',
        'beginningMarketValue',
        'additions',
        'deductions',
        'income',
        'adjustments',
        'marketFluctuation',
        'endingMarketValue'
      ];

      if (!ownsPershingAccounts) {
        columnDefOrder = columnDefOrder.filter(
          (column) => !ownsPershingAccounts && column !== 'adjustments'
        );
      }
      return columnDefOrder.map((field) =>
        columnDefFactory.createColumnDef(field)
      );
    };

    render() {
      const {
        accountsActivitySummary,
        maxInitialRowsToShow,
        performanceFilter,
        has529Only,
        hasPershingAccounts,
        hasAlaska529Only,
        autoGroupColumnDef,
        isDesktopLayout,
        sweepMap
      } = this.props;

      if (isEmpty(accountsActivitySummary)) {
        return (
        <div className="activity-summary-breakdown-no-rows-container">
          <span className="activity-summary-breakdown-no-rows-text">No Rows To Show</span>
        </div>
      )}

      const data = {
        columnDefs: this.generateColumnDefs(
          accountsActivitySummary,
          false,
          has529Only,
          hasPershingAccounts,
          hasAlaska529Only
        ),
        columnDefsRetirementOrder: this.generateColumnDefs(
          accountsActivitySummary,
          true,
          has529Only,
          hasPershingAccounts,
          hasAlaska529Only
        ),
        applyColumnDefOrder: true,
        defaultColDef
      };

      return (
        <WrappedComponent
          accountsActivitySummary={accountsActivitySummary}
          maxInitialRowsToShow={maxInitialRowsToShow}
          performanceFilter={performanceFilter}
          frameworkComponents={this.frameworkComponents}
          autoGroupColumnDef={autoGroupColumnDef}
          isDesktopLayout={isDesktopLayout}
          has529Only={has529Only}
          sweepMap={sweepMap}
          {...data}
        />
      );
    }
  }

  const mapStateToProps = (state) => {
    const { view } = state;
    const desktopLayout = isDesktopLayout(state);

    return {
      isDesktopLayout: desktopLayout,
      accountsActivitySummary: buildAccountsActivitySummary(state),
      maxInitialRowsToShow: view.maxInitialRowsToShow,
      performanceFilter: getActivitySummaryFilter(state),
      has529Only: has529Only(state),
      hasPershingAccounts: getHasPershingAccounts(state),
      hasAlaska529Only: hasAlaska529Only(state),
      autoGroupColumnDef: desktopLayout
        ? autoGroupColumnDef
        : autoGroupColumnDefMobile,
      sweepMap: getBrokerageAccountsFromSweepMap(state)
    };
  };

  return connect(mapStateToProps)(ActivitySummaryData);
};

export default ActivitySummaryDataProvider;
